(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sis-guide-steps"] && !Shopify.designMode) return;
  try {
    
  // Marks the step being read in the chips / side list, and the ones before it.
  if (!customElements.get('sis-guide-steps')) {
    customElements.define(
      'sis-guide-steps',
      class extends HTMLElement {
        connectedCallback() {
          const steps = [...this.querySelectorAll('.sis-step[data-step]')];
          const chips = [...this.querySelectorAll('.sis-steps__chip[data-step]')];
          if (!steps.length || !chips.length || !('IntersectionObserver' in window)) return;
          const mark = (n) => {
            chips.forEach((c) => {
              const k = Number(c.dataset.step);
              c.toggleAttribute('aria-current', k === n);
              c.classList.toggle('is-done', k < n);
            });
            const active = chips.find((c) => Number(c.dataset.step) === n);
            const bar = active && active.closest('.sis-steps__chips');
            if (bar && bar.scrollWidth > bar.clientWidth) {
              bar.scrollTo({ left: active.offsetLeft - 16, behavior: 'smooth' });
            }
          };
          this.io = new IntersectionObserver(
            (entries) => {
              const seen = entries.filter((e) => e.isIntersecting).map((e) => Number(e.target.dataset.step));
              if (seen.length) mark(Math.min(...seen));
            },
            { rootMargin: '-30% 0px -60% 0px' }
          );
          steps.forEach((s) => this.io.observe(s));
          mark(1);
        }
        disconnectedCallback() {
          if (this.io) this.io.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
